import MARKETING_SITE_URL from "../API/MARKETING_SITE_URL";
import Index from "../pages/Index";
import PageNotFound from "../pages/PageNotFound";
import NewSignUp from "../pages/NewSignUp";
import Login from "../pages/Login";
import ResetPassword from "../pages/ResetPassword";
import FeaturePage from "../pages/FeaturePage";
import ProtectedRoute from "../Routes/ProtectedRoute";
import Dashboard from "../product/dashboard.tsx";
import ResetPasswordLink from "../pages/ResetPasswordLink";
import ChangePassword from "../pages/ChangePassword";
import OAuthSuccess from "../pages/OAuthSuccess";
import ResetPasswordConfirm from "../pages/ResetPasswordConfirm";
import AnswerReview from "../pages/AnswerReview";
import AnswerReviewDownload from "../pages/AnswerReviewDownload";
import VisaEligibilityStep from "../components/StepperForm/VisaEligibilityStep.tsx";
import Feedback from "../product/Feedback";
import PaymentHistory from "../product/PaymentHistory";
import SubscriptionPackage from "../pages/SubscriptionPackage.tsx";
import VisaApplication from "../product/VisaApplication";
import Profile from "../product/Profile/index.tsx";
import ApplicationForm from "../product/ApplicationForm/index.tsx";
import UscisFee from "../product/UscisFee/index.tsx";
import ConnectAttorney from "../pages/ConnectAttorney.tsx";
import PaymentSuccess from "../pages/PaymentSuccess.tsx";
import PaymentCancelled from "../pages/PaymentCancelled.tsx";
import ChooseService from "../pages/ChooseService.tsx";
import FederalPovertyGuidelineCalculator from "../pages/FederalPovertyGuidelineCalculator.tsx";
import ApplicationDeepLinkRedirect from "../Routes/ApplicationDeepLinkRedirect.jsx";
import VerifyEmail from "../pages/VerifyEmail.tsx";

export const routesConfig = [
  {
    path: `${MARKETING_SITE_URL}/`,
    element: <Index />,
    name: "Home",
    showInNav: true,
    showInFooter: false,
    title: "Home",
    description:
      "Check your eligibility for U.S. citizenship. Answer a few quick questions to find out if you're eligible to apply for U.S. citizenship with LetsGetVisa.",
    authVisible: "logout",
  },

  {
    path: `${MARKETING_SITE_URL}/services/application-for-naturalization/`,
    name: "Our Services",
    showInNav: true,
    showInFooter: false,
    isButton: false,
    title: "Our Services",
    description:
      "Explore our comprehensive visa application services including naturalization, green card applications, and expert immigration guidance.",
    authVisible: "logout",
  },
  {
    path: `${MARKETING_SITE_URL}/about-us/`,
    name: "About Us",
    showInNav: true,
    showInFooter: false,
    title: "About Us",
    description:
      "Learn about LetsGetVisa and our mission to help individuals navigate the U.S. immigration process with confidence and ease.",
    authVisible: "logout",
  },
  {
    path: "/features/:slug",
    element: <FeaturePage />,
    name: "Feature",
    showInNav: false,
    title: "Feature",
    description:
      "Discover the features and capabilities of LetsGetVisa's visa application platform.",
    authVisible: "logout",
  },

  {
    path: `${MARKETING_SITE_URL}/blogs/`,
    name: "Blogs",
    showInNav: true,
    showInFooter: false,
    title: "Blogs",
    description:
      "Read the latest news, updates, and insights about U.S. immigration, visa applications, and citizenship processes.",
    authVisible: "logout",
  },
  {
    path: "/sign-up",
    element: <NewSignUp />,
    name: "Sign Up",
    showInNav: false,
    showInFooter: false,
    isButton: true,
    title: "Sign Up",
    description:
      "Create your free LetsGetVisa account to start your U.S. citizenship eligibility check and manage your visa application.",
    authVisible: "logout",
  },
  {
    path: "/verify-email",
    element: <VerifyEmail />,
    name: "Verify Email",
    showInNav: false,
    showInFooter: false,
    title: "Verify Email",
    description: "Verify your LetsGetVisa account email.",
    noindex: true,
  },

  {
    path: "/",
    element: <Login />,
    name: "Log In",
    showInNav: false,
    showInFooter: false,
    isButton: true,
    title: "Log In",
    description:
      "Sign in to your LetsGetVisa account to continue your visa application and access your dashboard.",
    authVisible: "logout",
  },

  {
    path: "/login",
    element: <Login />,
    name: "Log In",
    showInNav: true,
    showInFooter: false,
    isButton: true,
    title: "Log In",
    description:
      "Sign in to your LetsGetVisa account to continue your visa application and access your dashboard.",
    authVisible: "logout",
  },

  {
    path: "/reset-password",
    element: <ResetPassword />,
    name: "Reset Password",
    showInNav: false,
    showInFooter: false,
    isButton: true,
    title: "Reset Password",
    description:
      "Reset your LetsGetVisa account password. Enter your email to receive password reset instructions.",
    authVisible: "logout",
  },

  {
    path: "/reset-password-link",
    element: <ResetPasswordLink />,
    name: "Password Reset Link",
    showInNav: false,
    showInFooter: false,
    isButton: true,
    title: "Password Reset Link Sent",
    description:
      "Password reset link has been sent to your email. Please check your inbox to reset your password.",
    authVisible: "logout",
  },
  {
    path: "/subscription-package",
    element: <SubscriptionPackage />,
    name: "Subscription Package",
    showInNav: false,
    showInFooter: false,
    isButton: false,
    title: "Subscription Packages",
    description:
      "Choose the subscription package that best fits your visa application needs. Get access to expert guidance and application management tools.",
    authVisible: "logout",
  },

  //  {
  //   path: "/change-password",
  //   element:  <ChangePassword/>,
  //   name: "Change Password",
  //   showInNav: false,
  //   showInFooter: false, // Show in footer
  //    isButton: true,
  //   title: "Change Password ",
  //    authVisible: "logout",
  // },

  {
    path: `${MARKETING_SITE_URL}/contact-us/`,
    name: "Contact Us",
    isButton: false,
    showInNav: true,
    showInFooter: true,
    title: "Contact Us",
    description:
      "Get in touch with LetsGetVisa. Our team is here to help you with your visa application questions and support needs.",
    authVisible: "logout",
  },

  {
    path: "/blog",
    name: "Blogs",
    isButton: false,
    showInNav: false,
    showInFooter: true,
    title: "Blogs",
    description:
      "Read the latest news, updates, and insights about U.S. immigration, visa applications, and citizenship processes.",
  },

  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
    name: "Dashboard",
    showInNav: true,
    isButton: false,
    title: "Dashboard",
    description:
      "Manage your visa applications, track your progress, and access all your immigration documents in one place.",
    authVisible: "login",
  },

  {
    path: "/feedback",
    element: (
      <ProtectedRoute>
        <Feedback />
      </ProtectedRoute>
    ),
    name: "Feedback",
    showInNav: false,
    isButton: false,
    title: "Application Feedback",
    description:
      "Review feedback on your visa application answers and get recommendations for improvement.",
    authVisible: "login",
  },
  {
    path: "/visa-application",
    element: (
      <ProtectedRoute>
        <VisaApplication />
      </ProtectedRoute>
    ),
    name: "Visa Application",
    showInNav: false,
    isButton: false,
    title: "Visa Applications",
    description:
      "View and manage all your visa applications. Track progress, upload documents, and complete your forms.",
    authVisible: "login",
  },
  // Legacy deep links from email; must stay above catch-all `*` so they never hit PageNotFound.
  {
    path: "/applications/:applicationId",
    element: (
      <ProtectedRoute>
        <ApplicationDeepLinkRedirect />
      </ProtectedRoute>
    ),
    name: "Application redirect",
    showInNav: false,
    isButton: false,
    title: "Visa Application",
    description:
      "Redirects to your application hub. Sign in if prompted, then you continue on the visa application page.",
    authVisible: "login",
    noindex: true,
  },
  {
    path: "/profile",
    element: (
      <ProtectedRoute>
        <Profile />
      </ProtectedRoute>
    ),
    name: "Profile",
    showInNav: false,
    isButton: false,
    title: "My Profile",
    description:
      "Manage your LetsGetVisa account profile, update personal information, and change your password.",
    authVisible: "login",
  },
  {
    path: "/payment-history",
    element: (
      <ProtectedRoute>
        <PaymentHistory />
      </ProtectedRoute>
    ),
    name: "Payment History",
    showInNav: false,
    isButton: false,
    title: "Payment History",
    description:
      "View your payment history for visa application fees, USCIS fees, and subscription services.",
    authVisible: "login",
  },
  {
    path: "/federal-poverty-guideline-calculator",
    element: (
      <ProtectedRoute>
        <FederalPovertyGuidelineCalculator />
      </ProtectedRoute>
    ),
    name: "Federal Poverty Guideline Calculator",
    showInNav: false,
    isButton: false,
    title: "Federal Poverty Guideline Calculator",
    description:
      "Calculate whether your household income is at or under 400% of the Federal Poverty Guidelines for USCIS fee questions.",
    authVisible: "login",
  },
  {
    path: "/oauth-success",
    element: <OAuthSuccess />,
    name: "OAuth Success",
    showInNav: false,
    title: "Authentication Successful",
    description: "Your account has been successfully authenticated. Redirecting to your dashboard...",
    noindex: true,
  },

  {
    path: "/forgot-password/reset-password/:token",
    element: <ResetPasswordConfirm />,
    name: "Reset Password Confirm",
    title: "Reset Password",
    description:
      "Enter your new password to complete the password reset process for your LetsGetVisa account.",
    noindex: true,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPasswordConfirm />,
    name: "Reset Password Confirm",
    title: "Reset Password",
    description:
      "Enter your new password to complete the password reset process for your LetsGetVisa account.",
    noindex: true,
  },
  // {
  //   path: "/uscis-fee",
  //   element: (
  //     <ProtectedRoute>
  //       <UscisFee />
  //     </ProtectedRoute>
  //   ),
  //   name: "USCIS Fee",
  //   showInNav: false,
  //   isButton: false,
  //   authVisible: "login", // visible only when logged in
  // },
  {
    path: "/application/:id/uscis-fee",
    element: (
      <ProtectedRoute>
        <UscisFee />
      </ProtectedRoute>
    ),
    name: "USCIS Fee",
    showInNav: false,
    isButton: false,
    title: "USCIS Fee Payment",
    description:
      "Pay your USCIS application fees securely through LetsGetVisa. Complete your visa application payment process.",
    authVisible: "login",
  },
  {
    path: "/application",
    element: (
      <ProtectedRoute>
        <ApplicationForm />
      </ProtectedRoute>
    ),
    name: "Application Form",
    showInNav: false,
    isButton: false,
    title: "Application Form",
    description:
      "Complete your visa application form step by step. Get guidance and support throughout the application process.",
    authVisible: "login",
  },

  {
    path: "/change-password/:token",
    element: (
      <ProtectedRoute>
        <ChangePassword />
      </ProtectedRoute>
    ),
    name: "Change Password",
    showInNav: false,
    showInFooter: false,
    isButton: false,
    title: "Change Password",
    description:
      "Update your LetsGetVisa account password. Choose a strong password to keep your account secure.",
    authVisible: "login",
    noindex: true,
  },

  {
    path: "/answer-review",
    element: <AnswerReview />,
    name: "Visa Eligibility Review",
    showInNav: false,
    isButton: false,
    showInFooter: false,
    title: "Visa Eligibility Review",
    description:
      "Review your visa eligibility assessment results. See detailed feedback on your answers and eligibility status.",
    className: "btn-primary",
  },
  // {
  //   path: "/answer-review-download",
  //   element: <AnswerReviewDownload/>,
  //   name: "answer-review",
  //   showInNav: true
  // },
  {
    path: "/answer-review-download",
    element: <AnswerReviewDownload />,
    showInNav: false,
    isButton: false,
    showInFooter: true,
    name: "Visa Eligibility Download",
    title: "Download Eligibility Report",
    description:
      "Download your complete visa eligibility report as a PDF. Share it with your attorney or keep it for your records.",
    className: "btn-primary",
  },
  {
    path: "/services",
    element: (
      <ProtectedRoute>
        <ChooseService />
      </ProtectedRoute>
    ),
    name: "Choose Your Service",
    showInNav: false,
    isButton: false,
    showInFooter: false,
    title: "Choose Your Service",
    description:
      "Choose a visa service to start your eligibility check and application.",
    authVisible: "login",
  },
  {
    path: "/visa-eligibility",
    element: <VisaEligibilityStep />,
    showInNav: false,
    isButton: false,
    showInFooter: true,
    name: "Visa Eligibility",
    title: "Visa Eligibility Check",
    description:
      "Check your eligibility for U.S. citizenship. Answer a few questions to determine if you're eligible to apply.",
    className: "btn-primary",
  },
  {
    path: "/visa-eligibility/:visaType",
    element: <VisaEligibilityStep />,
    showInNav: false,
    isButton: false,
    showInFooter: false,
    name: "Visa Eligibility Steps",
    title: "Visa Eligibility Assessment",
    description:
      "Complete your visa eligibility assessment by answering questions about your immigration status and background.",
  },
  {
    path: "/connect-attorney",
    element: <ConnectAttorney />,
    name: "Connect Attorney",
    showInNav: false,
    isButton: false,
    showInFooter: false,
    title: "Connect with Attorney",
    description:
      "Schedule a consultation with an experienced immigration attorney. Get expert guidance on your visa application process.",
    authVisible: "logout",
  },
  {
    path: "/payment/success",
    element: <PaymentSuccess />,
    name: "Payment Success",
    showInNav: false,
    isButton: false,
    showInFooter: false,
    title: "Payment Successful",
    description:
      "Your payment has been processed successfully. Your visa application fees have been paid and your application is being processed.",
    noindex: true,
  },
  {
    path: "/payment/cancelled",
    element: <PaymentCancelled />,
    name: "Payment Cancelled",
    showInNav: false,
    isButton: false,
    showInFooter: false,
    title: "Payment Cancelled",
    description:
      "Your payment was cancelled. You can complete the payment process later from your dashboard or payment history.",
    noindex: true,
  },
  // Catch-all must remain last or specific routes (e.g. /applications/:id) never match.
  {
    path: "*",
    element: <PageNotFound />,
    name: "NotFound",
    showInNav: false,
    showInFooter: false,
    title: "404 - Page Not Found",
    description:
      "The page you're looking for doesn't exist. Return to LetsGetVisa homepage to continue your visa application journey.",
    noindex: true,
  },
];
